/**
 * Touch dropdown handling for tablet/touch devices.
 * Desktop keeps CSS hover behavior; touch gets click-to-toggle.
 */
function initTouchDropdowns() {
  const isTouchLike = window.matchMedia?.('(hover: none), (pointer: coarse)')?.matches ?? false;

  if (!isTouchLike) return;

  // Avoid using :has() for broader iPad Safari support.
  const containers = Array.from(document.querySelectorAll('header .group')).filter(
    (el) =>
      el.querySelector(':scope > .mega_dropdown') || el.querySelector(':scope > .dropdown_menu')
  );

  if (!containers.length) return;

  const closeAll = (exceptEl = null) => {
    containers.forEach((c) => {
      if (exceptEl && c === exceptEl) return;
      c.classList.remove('is-open');
      const btn = c.querySelector(':scope > button.menu_item');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  };

  // Close on outside tap/click.
  document.addEventListener(
    'click',
    (e) => {
      const target = e.target;
      if (!(target instanceof Element)) return;
      if (target.closest('header .group.is-open')) return;
      closeAll();
    },
    { passive: true }
  );

  containers.forEach((container) => {
    const button = container.querySelector(':scope > button.menu_item');
    if (!button) return;

    button.setAttribute('aria-haspopup', 'true');
    button.setAttribute(
      'aria-expanded',
      container.classList.contains('is-open') ? 'true' : 'false'
    );

    button.addEventListener('click', (e) => {
      // Stop the click from immediately triggering the document outside handler.
      e.preventDefault();
      e.stopPropagation();

      const nextOpen = !container.classList.contains('is-open');
      closeAll(container);
      container.classList.toggle('is-open', nextOpen);
      button.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
    });
  });
}

document.addEventListener('DOMContentLoaded', initTouchDropdowns);
